/** Bot difficulty levels. The WPM is the bots' average; each bot varies ±25% around it. */
export interface Difficulty {
  id: string;
  name: string;
  wpm: number;
  blurb: string;
}

export const DIFFICULTIES: Difficulty[] = [
  { id: 'beginner', name: 'Beginner', wpm: 20, blurb: 'Just learning the keys' },
  { id: 'easy', name: 'Easy', wpm: 30, blurb: 'Casual typist' },
  { id: 'medium', name: 'Medium', wpm: 45, blurb: 'Average office typist' },
  { id: 'hard', name: 'Hard', wpm: 60, blurb: 'Confident touch typist' },
  { id: 'expert', name: 'Expert', wpm: 80, blurb: 'Fast and accurate' },
  { id: 'pro', name: 'Pro', wpm: 100, blurb: 'Competition speed' },
];

export const DEFAULT_DIFFICULTY = 'medium';

/** The level whose WPM is closest to the given bot speed. */
export function difficultyForWpm(wpm: number): Difficulty {
  let best = DIFFICULTIES[0]!;
  for (const d of DIFFICULTIES) if (Math.abs(d.wpm - wpm) < Math.abs(best.wpm - wpm)) best = d;
  return best;
}

export function difficultyLabel(wpm: number): string {
  const d = difficultyForWpm(wpm);
  return d.wpm === wpm ? `${d.name} (${d.wpm} WPM)` : `Custom (${wpm} WPM)`;
}
